import { render, staticRenderFns } from "./templateShop.vue?vue&type=template&id=63cd1ac3&scoped=true&"
import script from "./templateShop.vue?vue&type=script&lang=js&"
export * from "./templateShop.vue?vue&type=script&lang=js&"
import style0 from "./templateShop.vue?vue&type=style&index=0&id=63cd1ac3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../cache/node/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cd1ac3",
  null
  
)

export default component.exports